import React from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => {
  return (
    <div className="w-full flex-1 min-w-0 relative">
      <Search className="absolute left-3 top-2 w-4 h-4 text-slate-400" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-slate-50/50 border border-slate-200 outline-none rounded-lg py-1.5 pl-9 pr-4 text-sm focus:ring-1 focus:ring-custom-primary font-medium"
      />
    </div>
  );
};
